import React from 'react';
import { Card, Col, Row } from 'reactstrap';

import styles from './style.module.scss';

import SalesAnalysis from './SalesAnalysis';
import InventoryAnalysis from './InventoryAnalysis';
import ContributionForProduct from './ContributionForProduct';
import SalesGrowthAnalysis from './SalesGrowthAnalysis';
import MarginAnalysis from './MarginAnalysis';

interface Props {
  isCallRequired: boolean;
  onLoadEnd: () => void;
}

interface State {
  isExpanded: boolean,
  tabList: string[];
  selectedTab: string;
}

export default class ChartDashboard extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: false,
      tabList: [
        'Sales Analysis',
        'Inventory Analysis',
        'Contribution for Product',
        'Sales Growth Analysis',
        'Margin Analysis'
      ],
      selectedTab: 'Sales Analysis'
    };
  }

  render(): React.ReactNode {
    return (
      <React.Fragment>
        <Row>
          <Col md={12}>

            <Card body className={styles['filter-card']}>

              <Row>
                <Col md={6} className="d-flex align-items-center">
                  <i className="ri-dashboard-line font-size-20 me-2"/>
                  <span className={styles['section-label']}>Dashboard</span>
                </Col>

                <Col md={6} className="text-right">
                  <i className={`ri-arrow-${this.state.isExpanded ? 'up' : 'down'}-s-line p-2 cursor-pointer`}
                     style={{fontSize: '22px'}}
                     onClick={() => this.setState({isExpanded: !this.state.isExpanded})}
                  />
                </Col>
              </Row>

              {
                this.state.isExpanded &&
                <React.Fragment>
                    <div className="d-flex">
                      {
                        this.state.tabList.map((tab, tabIdx: number) => (
                          <div
                            key={tabIdx}
                            className={`tab ${tab === this.state.selectedTab ? 'active' : ''}`}
                            onClick={() => this.setState({selectedTab: tab})}
                          >
                            <p className={`tab-text ${tab === this.state.selectedTab ? 'active' : ''}`}>
                              {tab}
                            </p>
                          </div>
                        ))
                      }
                    </div>

                  {
                    this.state.selectedTab === 'Sales Analysis' &&
                    <SalesAnalysis
                        isCallRequired={this.props.isCallRequired}
                        onLoadEnd={() => this.props.onLoadEnd()}
                    />
                  }

                  {
                    this.state.selectedTab === 'Inventory Analysis' &&
                    <InventoryAnalysis
                        isCallRequired={this.props.isCallRequired}
                        onLoadEnd={() => this.props.onLoadEnd()}
                    />
                  }

                  {
                    this.state.selectedTab === 'Contribution for Product' &&
                    <ContributionForProduct/>
                  }

                  {
                    this.state.selectedTab === 'Sales Growth Analysis' &&
                    <SalesGrowthAnalysis
                        isCallRequired={this.props.isCallRequired}
                        onLoadEnd={() => this.props.onLoadEnd()}
                    />
                  }

                  {
                    this.state.selectedTab === 'Margin Analysis' &&
                    <MarginAnalysis
                        isCallRequired={this.props.isCallRequired}
                        onLoadEnd={() => this.props.onLoadEnd()}
                    />
                  }
                </React.Fragment>
              }

            </Card>

          </Col>
        </Row>
      </React.Fragment>
    );
  }
}
